module.exports = __webpack_public_path__ + "static/media/caresee-app.fa1b6cbb.png";